<template>
  <div class="splash">
    <img :src="splashImg" alt="">
    <h2>{{text}}</h2>
    <button class="btn btn-primary"
            @click="$emit('nextSlide')">
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  props: [
    'splashImg', 'text', 'index', 'buttonText'
  ],
name: "Splash",
  created() {
    document.addEventListener('keydown', (e)=>{
      try {
        if(this.index===0)
          if(e.code==='Enter'){
            this.$emit('nextSlide')
          }
      }catch(err) {
        console.log(err)
      }

    })
  }
}
</script>

<style lang="scss" scoped>

.splash{

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img{
    max-width: 508px;
    width: 100%;
  }
  h2{
    max-width: 508px;
    width: 100%;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    text-align: center;
    color: #52595E;
    margin-bottom: 0;
  }
  .btn{
    margin-top: 33px;
    box-shadow: none;
    border-radius: 32px;
    text-transform: capitalize;

    &:hover{
      background: #557efb;
      box-shadow: 0 13px 27px 0 rgba(85, 126, 251, 0.75);
    }
    &::after,
    &::before{
      content: none
    }
  }
}

</style>
